'use client';

import React from 'react';
import { CircularProgress } from 'src/components';

interface MapLoadingIndicatorProps {
  message?: string;
}

const MapLoadingIndicator: React.FC<MapLoadingIndicatorProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div
      className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-white/95 backdrop-blur-sm rounded-full px-4 py-3 shadow-lg z-[1000]"
      role="status"
      aria-label={message}
      data-testid="map-loading-indicator"
    >
      <div className="flex items-center gap-2">
        <CircularProgress size="sm" color="primary" />
        <span className="text-sm font-medium text-neutral-700">{message}</span>
      </div>
    </div>
  );
};

export default MapLoadingIndicator;
